/* Component Dependencies */
var weddingServicesTemplate = require('templates/weddingServices.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
    type: 'weddingServices',
    template: {
        'weddingServices': weddingServicesTemplate
    }
});